
const HISTORY_API_URL =
  "https://orbiee-backend-dev-218142584790.us-central1.run.app/api/sessions/history";

export const fetchChatHistory = async (userId, deviceId) => {
  if (!userId) {
    throw new Error("userId is required");
  }

  const headers = {
    Accept: "application/json",
    "X-User-Id": String(userId),
  };

  if (deviceId) {
    headers["X-Device-Id"] = String(deviceId);
  }

  const response = await fetch(HISTORY_API_URL, {
    method: "GET",
    headers,
  });

  if (!response.ok) {
    throw new Error(
      `Failed to fetch chat history: ${response.status}`
    );
  }

  return response.json();
};
